const styles = () => ({
    containerTitle: {
        alignItems: 'center',
        marginTop: '20px',
    },
    title: {
        fontWeight: '500',
        margin: '0',
    },
    radioGroup: {
        width: '100%',
        display: 'flex',
    },
});

export default styles;
